import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Screen\GetScreenConfigController::__invoke
* @see app/Http/Controllers/Screen/GetScreenConfigController.php
* @route '/api/screen/{screen}/config'
*/
const GetScreenConfigController = (args: { screen: string | number | { id: string | number } } | [screen: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetScreenConfigController.url(args, options),
    method: 'get',
})

GetScreenConfigController.definition = {
    methods: ["get","head"],
    url: '/api/screen/{screen}/config',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Screen\GetScreenConfigController::__invoke
* @see app/Http/Controllers/Screen/GetScreenConfigController.php
* @route '/api/screen/{screen}/config'
*/
GetScreenConfigController.url = (args: { screen: string | number | { id: string | number } } | [screen: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { screen: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { screen: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            screen: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        screen: typeof args.screen === 'object'
        ? args.screen.id
        : args.screen,
    }

    return GetScreenConfigController.definition.url
            .replace('{screen}', parsedArgs.screen.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Screen\GetScreenConfigController::__invoke
* @see app/Http/Controllers/Screen/GetScreenConfigController.php
* @route '/api/screen/{screen}/config'
*/
GetScreenConfigController.get = (args: { screen: string | number | { id: string | number } } | [screen: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetScreenConfigController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Screen\GetScreenConfigController::__invoke
* @see app/Http/Controllers/Screen/GetScreenConfigController.php
* @route '/api/screen/{screen}/config'
*/
GetScreenConfigController.head = (args: { screen: string | number | { id: string | number } } | [screen: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetScreenConfigController.url(args, options),
    method: 'head',
})

export default GetScreenConfigController